import {
  getStoredSelectedResourceId,
  selectAvailableResourceId,
  selectedResourceExists,
  setStoredSelectedResourceId,
} from "@/utils/selectedResourceUtils";

const SELECTED_FLEET_PARK_STORAGE_KEY = "fleet.selectedFleetParkId";

/**
 * Утилиты предметного выбора автопарка для FleetPage. Общая работа с
 * localStorage и проверкой доступности находится в selectedResourceUtils;
 * здесь остаётся формат numeric ID и правило первого входа в автопарк.
 */

/**
 * Возвращает сохранённый ID автопарка числом. Неподходящее или недоступное
 * значение не используем: FleetPage дополнительно проверяет его по backend.
 */
export function getSelectedFleetParkId() {
  const fleetParkId = getStoredSelectedResourceId(
    SELECTED_FLEET_PARK_STORAGE_KEY
  );
  if (!/^\d+$/.test(String(fleetParkId || ""))) return null;

  return Number(fleetParkId);
}

/**
 * Запоминает автопарк, выбранный пользователем, чтобы при следующем входе
 * открыть тот же календарь.
 */
export function saveSelectedFleetParkId(fleetParkId) {
  setStoredSelectedResourceId(
    SELECTED_FLEET_PARK_STORAGE_KEY,
    fleetParkId
  );
}

// Удаляет сохранённый выбор, например когда выбранный автопарк удалён.
export function removeSelectedFleetParkId() {
  setStoredSelectedResourceId(SELECTED_FLEET_PARK_STORAGE_KEY, null);
}

/**
 * Выбирает автопарк при открытии страницы: ссылка с fleet_park_id важнее
 * сохраненного UX-выбора, но оба значения применяются только если они есть
 * среди автопарков, загруженных из backend. При первом входе без выбора
 * открывает первый доступный автопарк.
 */
export function selectFleetParkId({
  routeFleetParkId = null,
  savedFleetParkId = null,
  fleetParkOptions = [],
}) {
  return selectAvailableResourceId({
    routeResourceId: routeFleetParkId,
    savedResourceId: savedFleetParkId,
    resources: fleetParkOptions,
    getResourceId: (fleetPark) => fleetPark.value,
    fallbackId: fleetParkOptions[0]?.value || null,
  });
}

// Проверяет, существует ли автопарк среди options, полученных для селектора.
export function fleetParkExists(fleetParkId, fleetParkOptions = []) {
  return selectedResourceExists(
    fleetParkId,
    fleetParkOptions,
    (fleetPark) => fleetPark.value
  );
}
